import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from '../serviceHelper'

export const adminNotificationService = {
  getEmailRedirectionData: async (user) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/admin/notification/email-redirection`,
        getAxiosOptions(user)
      )
    ).data
  },
  saveEmailRedirectionData: async (user, payload) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/notification/save-email-redirection`,
        payload,
        getAxiosOptions(user)
      )
    ).data
  },
  deleteEmailRedirectionData: async (user, fromEmail) => {
    return (
      await axios.delete(
        `${NODE_BASE_URL}/admin/notification/delete-email-redirection/${fromEmail}`,
        getAxiosOptions(user)
      )
    ).data
  },
  getCustomNotificationTemplates: async (user) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/admin/notification/custom-notification-templates/${user.company_id}`,
        getAxiosOptions(user)
      )
    ).data
  },
  saveCustomNotificationTemplate: async (user, payload) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/admin/notification/save-custom-notification-template`,
        payload,
        getAxiosOptions(user)
      )
    ).data
  },
  updateCustomNotificationTemplate: async (user, templateId, payload) => {
    return (
      await axios.put(
        `${NODE_BASE_URL}/admin/notification/update-custom-notification-template/${templateId}`,
        payload,
        getAxiosOptions(user)
      )
    ).data
  },
  deleteCustomNotificationTemplate: async (user, templateId) => {
    return (
      await axios.delete(
        `${NODE_BASE_URL}/admin/notification/delete-custom-notification-template/${templateId}`,
        getAxiosOptions(user)
      )
    ).data
  },
}
